import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicReferralsService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public createBulk(sponsor_id: string | number, emails: string[]): Observable<any> {
    return this.publicHttp
      .post("/api/persons/" + sponsor_id + "/referrals", { referral_emails: emails })
      .pipe(tap((_) => console.log("PublicReferralsService.createBulk: Ok.")));
  }

  public getSponsorId(sponsor_id: string | number): Observable<any> {
    return this.publicHttp
      .get("/api/persons/" + sponsor_id + "/referrals")
      .pipe(tap((_) => console.log("PublicReferralsService.getSponsorId: Ok.")));
  }

  public reinvite(sponsor_id: string | number, email: string): Observable<any> {
    const data = { referral_email: email };
    return this.publicHttp
      .post("/api/persons/" + sponsor_id + "/referrals/reinvite", data)
      .pipe(tap((_) => console.log("PublicReferralsService.reinvite: Ok.")));
  }
}
